import React from 'react';
import "./Styles/InterventionPlan.css";
import NavBar from '../NavBar';
import Footer from '../Footer';
import InterventionPlan from './Components/InterventionPlanRoute/InterventionPlan';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function InterventionPlanRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="InterventionPlanRoutePage">
                    <div className="InterventionPlanRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="InterventionPlanRouteForm">
                        <InterventionPlan/>
                    </div>
                    <div className="InterventionPlanRouteFooter">
                        <Footer/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default InterventionPlanRoute;